import React from "react";
import { Box, Typography, Skeleton, IconButton, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useTranslation } from "react-i18next";

const BomPathView = ({
	tree = [],
	isLoading = false,
	emptyLabel = "No BOM path available.",
	onNavigateToProduct,
}) => {
	const { t } = useTranslation();
	if (isLoading) {
		return (
			<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
				{Array.from({ length: 4 }).map((_, idx) => (
					<Skeleton key={idx} variant="rounded" height={28} />
				))}
			</Box>
		);
	}

	if (!tree || tree.length === 0) {
		return (
			<Typography variant="body2" color="text.secondary">
				{emptyLabel}
			</Typography>
		);
	}

	const renderNodes = (nodes = [], depth = 0) =>
		nodes.map((node) => (
			<Box key={node.nodeId || `${node.productNumber}-${depth}`} sx={{ pl: depth * 2, py: 0.5 }}>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						borderLeft: depth ? "1px solid rgba(0,0,0,0.1)" : "none",
						ml: depth ? 1 : 0,
						pl: depth ? 1 : 0,
					}}
				>
					<Box sx={{ flexGrow: 1, minWidth: 0 }}>
						<Typography variant="body2" fontWeight={depth === 0 ? 600 : depth === 1 ? 500 : 400} noWrap>
							{node.productNumber || node.productName || "Part"}
						</Typography>
						{node.productName && node.productName !== node.productNumber ? (
							<Typography variant="caption" color="text.secondary" noWrap>
								{node.productName}
							</Typography>
						) : null}
					</Box>
					{onNavigateToProduct && node.productId && node.children && node.children.length > 0 ? (
						<Tooltip title={t("UI_TEXT.TOOLTIP_OPEN_PART_DETAILS")}>
							<IconButton
								size="small"
								onClick={() => onNavigateToProduct(node.productId)}
								sx={{ ml: 1 }}
							>
								<OpenInNewIcon fontSize="inherit" />
							</IconButton>
						</Tooltip>
					) : null}
				</Box>
				{node.children && node.children.length > 0 ? renderNodes(node.children, depth + 1) : null}
			</Box>
		));

	return <Box>{renderNodes(tree)}</Box>;
};

export default BomPathView;
